<template src="./templates/market.html"></template>

<script>
import {useStore, mapGetters, mapMutations} from 'vuex';
import {Modal} from 'bootstrap';

import useVuelidate from '@vuelidate/core';
import {
    required, minLength, maxLength, helpers
} from '@vuelidate/validators';
import {codeCheck} from '@api/promocode';
import ProductItem from './components/ProductItem';
import PrivilegeItem from './components/PrivilegeItem';
import Form from './components/Form';
import {dataRepository} from './repositories/data';
import {productsRepository} from './repositories/products';
import {cartRepository} from './repositories/cart';


import FreeDeliveryNotify from './wrappers/FreeDeliveryNotify';

export default {
    name: 'Market',
    components: {
        ProductItem,
        PrivilegeItem,
        FreeDeliveryNotify,
        Form,
        Modal
    },
    setup() {
        const store = useStore();

        const {
            loadData,
            dataLoading,
            products,
            config,
            pickupTowns,
            discount_config,
            reviews
        } = dataRepository();

        const {
            setFilter,
            filters,
            currentFilter,
            displayedProducts
        } = productsRepository(products);

        const {
            addProduct,
            inputProductCount,
            productsInCart,
            productInCartCount,
            totalCountInCart,
            totalPriceInCart,
            sendCart,
            cartItems,
            promoIsOn,
            promoCode
        } = cartRepository(products);

        return {
            store,
            dataLoading,
            loadData,
            products,
            setFilter,
            currentFilter,
            filters,
            displayedProducts,
            addProduct,
            inputProductCount,
            productsInCart,
            productInCartCount,
            totalCountInCart,
            totalPriceInCart,
            sendCart,
            cartItems,
            promoIsOn,
            promoCode,
            config,
            pickupTowns,
            discount_config,
            reviews,
            v$: useVuelidate()
        };
    },
    data() {
        return {
            isA: false,
            widgetInited: false,
            vkTimeAuth: null,
            user: {},
            showVkAllowMessages: false,
            vkAllowMessages: false,
            openCollapseId: null,
            responseError: null,
            confirmText: null,
            privilege: [
                {
                    title: 'Бесплатная пересылка от 10 шпаргалок',
                    description: 'При заказе от 10 шпаргалок оплату пересылки мы берём на себя.',
                },
                {
                    title: 'Самая быстрая доставка',
                    // eslint-disable-next-line max-len
                    description: 'Заказ отправляем в течение 2 рабочих дней после оформления из Минска Белпочтой (бизнес-почтой), поэтому у нас самая быстрая доставка. Посылка придёт на следующий день после отправки.',
                },
                {
                    title: 'Оплата при получении',
                    description: 'Посылку вы оплачиваете только при получении в отделении почты (наложенный платёж).',
                },
                {
                    title: 'Уведомления о статусе заказа',
                    description: 'Вы всегда будете проинформированы о статусе заказа сообщениями на указанный номер телефона в заказе. А после отправки придёт ещё и ссылка на отслеживание вашей посылки.',
                },
            ],
            alert_text: null,
            pickup_date: null,
            popupWin: null,
            addressCheck: false,
            formLoader: false,
            byType: 0,
            alert: false,
            wordSearch: '',
            showInside: false,
            vkTime: null,
            discountSteps: [
                {
                    id: 0,
                    count: 10,
                    title: 'До бесплатной пересылки',
                    notify: 'Бесплатная пересылка на весь заказ',
                    factor: 1,
                    discountLabel: null
                },
                {
                    id: 1,
                    count: 20,
                    title: 'До скидки 10%',
                    notify: '10% скидка на весь заказ',
                    factor: 0.9,
                    discountLabel: '10%'
                },
                {
                    id: 2,
                    count: 30,
                    title: 'До скидки 20%',
                    notify: '20% скидка на весь заказ',
                    factor: 0.8,
                    discountLabel: '20%'
                }
            ],
            toasts: [],
            promoLoader: false,
            promoInfo: null,
            promoValid: null,
            promoIsInvalid: false
        };
    },
    validations() {
        const form = {
            town: {
                required: helpers.withMessage('Укажите населённый пункт', required),
            },
            street: {
                required: helpers.withMessage('Укажите улицу', required),
            },
            name: {
                required: helpers.withMessage('Это поле не может быть пустым', required),
                regex: helpers.withMessage('Имя должно состоять только из букв русского алфавита и без пробелов', helpers.regex(/^([А-Яа-яёЁ]*|[А-Яа-яёЁ]{1}\.)$/))
            },
            phone: {
                required: helpers.withMessage('Это поле не может быть пустым', required),
                minLength: helpers.withMessage('Номер должен состоять из 9 цифр', minLength(9)),
                maxLength: helpers.withMessage('Номер должен состоять из 9 цифр', maxLength(9)),
                regex: helpers.withMessage('Номер должен начинаться с цифр 25, 29, 33 либо 44', helpers.regex(/^(25|29|33|44)[0-9]*$/)),
            },
            house: {
                required: helpers.withMessage('Это поле не может быть пустым', required),
                maxLength: helpers.withMessage('Номер дома может состоять максимум из 4 цифр', maxLength(4)),
                regex: helpers.withMessage('Номер дома может состоять только из цифр. Если номер дома состоит из цифр и букв, букву впишите в поле "Корпус"', helpers.regex(/^[0-9]*$/)),
            },
            pav: {
                maxLength: helpers.withMessage('Номер корпуса может состоять максимум из 4 символов', maxLength(4)),
                // regex: helpers.regex(/^[0-9А-Яа-я/]*$/)
                regex: helpers.withMessage('Некорректно указан корпус; примеры допустимых обозначений: «А», «2», «Б/2» и т.д.', helpers.regex(/^([А-Яа-я]{1}|[А-Яа-я]{1}\/[0-9]*|[0-9]*)$/)),
            },
            door_num: {
                maxLength: helpers.withMessage('Номер подъезда может состоять максимум из 4 символов', maxLength(4)),
                regex: helpers.withMessage('Номер подъезда может состоять только из цифр', helpers.regex(/^[0-9]*$/)),
            },
        };

        if (this.form.byType === 0) {
            Object.assign(form, {
                surname: {
                    required: helpers.withMessage('Это поле не может быть пустым', required),
                    minLength: helpers.withMessage('Фамилия должна содержать минимум 2 символа', minLength(2)),
                    regex: helpers.withMessage('Фамилия должна состоять только из букв русского алфавита и без пробелов', helpers.regex(/^[-А-Яа-яёЁ]*$/))
                },
                patronymic: {
                    regex: helpers.withMessage('Отчество должно состоять только из букв русского алфавита и без пробелов', helpers.regex(/^([А-Яа-яёЁ]*|[А-Яа-яёЁ]{1}\.)$/))
                },
                apart: {
                    maxLength: helpers.withMessage('Номер квартиры может состоять максимум из 5 символов', maxLength(5)),
                    regex: helpers.withMessage('Номер квартиры может состоять только из цифр', helpers.regex(/^[0-9]*$/)),
                },
                index: {
                    required: helpers.withMessage('Это поле не может быть пустым', required),
                    minLength: helpers.withMessage('Индекс должен состоять из 6 цифр', minLength(6)),
                    maxLength: helpers.withMessage('Индекс должен состоять из 6 цифр', maxLength(6)),
                    regex: helpers.regex(/^(2)[0-9]{5}$/)
                },
            });
        }

        return {
            form
        };
    },
    computed: {
        ...mapGetters([
            'reviews',
            'isLoading',
            'form',
            'formErrors',
            'formAttrs',
            'estimatedDeliveryDate'
        ]),
        discountPriceFactor() {
            return this.currentDiscountStep ? this.currentDiscountStep.factor : 1;
        },
        priceDiscount() {
            let totalPrice = this.totalPriceInCart;

            if (this.promoValid === true) {
                totalPrice = this.totalCountInCart * 400;
            }

            return totalPrice * this.discountPriceFactor;
        },
        nextDiscountStep() {
            if (this.totalCountInCart < this.discountSteps[0].count) {
                return this.discountSteps[0];
            }

            if (this.totalCountInCart < this.discountSteps[1].count) {
                return this.discountSteps[1];
            }

            return this.discountSteps[2];
        },
        countToNextDiscountStep() {
            return this.nextDiscountStep.count - this.totalCountInCart;
        },
        currentDiscountStep() {
            if (this.totalCountInCart >= this.discountSteps[2].count) {
                return this.discountSteps[2];
            }
            if (this.totalCountInCart >= this.discountSteps[1].count) {
                return this.discountSteps[1];
            }
            if (this.totalCountInCart >= this.discountSteps[0].count) {
                return this.discountSteps[0];
            }

            return null;
        },
        discountDeliveryStep() {
            return this.discountSteps[0];
        },
        deliveryPrice() {
            if (this.deliveryIsFree && this.form.byType === 0) {
                return 0;
            }

            return this.form.byType === 0 ? 576 : 1000;
        },
        totalPriceInCartLabel() {
            return this.$filters.currencyFormatted(this.totalPriceInCart);
        },
        fullName() {
            const items = [
                this.form.surname,
                this.form.name,
                this.form.patronymic,
            ];

            return items.filter(i => i).map(i => this.cap(i)).join(' ');
        },
        selectedAddressString() {
            const address = [];
            const {
                town, street, house, pav, apart
            } = this.form;

            if (town) {
                if (town.district) {
                    address.push(`${this.cap(town.district.region.name)} обл.`);
                    address.push(`${this.cap(town.district.name)} р-н`);
                }
                address.push(`${town.type.short_name} ${this.cap(town.name)}`);
            }

            if (street) {
                address.push(`${street.type.short_name} ${this.cap(street.name)}`);
            }

            if (house) {
                address.push(`д. ${house}`);
            }

            if (pav) {
                address.push(`корп. ${pav}`);
            }

            if (apart) {
                address.push(`кв. ${apart}`);
            }

            return address.join(', ');
        },
        deliveryIsFree() {
            if (!this.config.count_for_delivery_free || this.form.byType === 1) {
                return false;
            }

            return this.totalCountInCart >= this.config.count_for_delivery_free;
        },
        countToFreeDelivery() {
            return this.config.count_for_delivery_free - this.totalCountInCart;
        },
        percToFreeDelivery() {
            const ref = this.totalCountInCart / this.nextDiscountStep.count;
            return ref * 100;
        },
        scrollBoxWidth() {
            const elems = document.getElementsByClassName('thumb_block');
            let width = 0;

            [].forEach.call(elems, element => {
                width += element.offsetWidth;
            });
            return width;
        },
    },
    watch: {
        currentDiscountStep(step, oldStep) {
            if (this.totalCountInCart > 0 && step !== oldStep && this.form.byType === 0) {

                const notifies = this.discountSteps
                    .filter(s => {
                        if (s.id === 1 && this.totalCountInCart >= this.discountSteps[2].count) {
                            return false;
                        }

                        return this.totalCountInCart >= s.count;
                    })
                    .map(s => `– ${s.notify}`);

                if (notifies.length) {

                    const timer = setTimeout(() => {
                        this.toasts.shift();
                    }, 4000);

                    this.toasts.push({
                        id: Date.now() + Math.random(),
                        text: notifies.join('<br>'),
                        timer
                    });
                }
            }
        },
        'form.byType'(newValue) {
            if (newValue === 1) {
                this.setTown(this.pickupTowns.minsk);
            }
        }
    },
    mounted() {
        // this.store.dispatch('loadData');
        this.getUserAuth();
        this.loadData();
    },
    methods: {
        ...mapMutations([
            'setByType',
            'setTown'
        ]),
        deleteNotify(id) {
            const idx = this.toasts.findIndex(t => t.id === id);
            if (idx !== -1) {
                clearTimeout(this.toasts[idx].timer);
                this.toasts.splice(idx, 1);
            }
        },
        cap(value) {
            if (!value) return '';
            const string = value.toString();
            return string.toString().charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        },
        async nextStep(confirm = false) {
            this.responseError = null;
            const result = await this.v$.$validate();
            if (result) {
                const class11 = this.cartItems.some(item => !!this.products.find(product => product.id === item.productId && product.class === '11'));

                if (confirm && class11) {
                    this.confirmText = '<p>В вашем заказе выбраны шпаргалки <b>для колледжей</b>. '
                        + 'Шпаргалки для колледжей не подходят для сдачи экзамена в <b>9 классе</b>.</p>'
                        + '<p>Вы уверены, что хотите оставить шпаргалки для колледжей в заказе?</p>';
                    const modal = new bootstrap.Modal('#confirmModal');
                    modal.show();
                } else {
                    this.formSubmit();
                }
            } else {
                const modal = new bootstrap.Modal('#errorModal');
                modal.show();
            }
        },
        formSubmit() {
            this.responseError = null;

            if (this.formLoader) {
                return;
            }

            this.formLoader = true;

            this.sendCart({
                cart: this.cartItems,
                form: this.form,
                promoCode: this.promoCode
            }, response => {
                if (response.error) {
                    this.responseError = response.error;

                    const confirmModal = new bootstrap.Modal('#confirmModal');
                    confirmModal.hide();

                    const modal = new bootstrap.Modal('#errorModal');
                    this.formLoader = false;
                    modal.show();
                } else if (response.id) {
                    document.location.href = `/market/default/order-info?h=${response.id}`;
                }
            });
        },
        getParams() {
            return this.popupWin
                .location
                .search
                .replace('?', '')
                .split('&')
                .reduce(
                    (p, e) => {
                        const a = e.split('=');
                        p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                        return p;
                    },
                    {}
                );
        },
        openPopup(url) {
            this.popupWin = window.open(url, '', 'width=420,height=230');

            this.vkTime = setInterval(() => {
                if (this.popupWin.closed) {
                    this.getUserAuth();
                    clearInterval(this.vkTime);
                }
            }, 500);

            this.vkTimeAuth = setInterval(() => {
                if (!this.vkAllowMessages) {
                    this.getUserAuth();
                } else {
                    clearInterval(this.vkTimeAuth);
                }
            }, 1000);
        },
        getUserAuth() {
            this.axios.get('/market/api/user')
                .then(response => response.data)
                .then(data => {
                    this.user = data;
                    if (data && data.vk && !data.vk.message_allow) {
                        this.showVkAllowMessages = true;
                        this.vkAllowMessages = false;
                    } else if (data && data.vk && data.vk.message_allow) {
                        this.showVkAllowMessages = false;
                        this.vkAllowMessages = true;
                    }
                });
        },
        getPopupWin() {
            setTimeout(() => (this.popupWin ? this.popupWin.location.href : ''), 500);
        },
        vkAuth() {
            const host = window.location.hostname;
            const redirect = `https://${host}/vk-auth/index`;
            this.openPopup(`https://oauth.vk.com/authorize?client_id=7230183&display=popup&response_type=code&redirect_uri=${redirect}`);
        },
        initVkWidget() {
            if (!this.widgetInited) {
                VK.Widgets
                    .AllowMessagesFromCommunity(
                        'vk_allow_messages_from_community',
                        {height: 30},
                        81631540
                    );
                this.widgetInited = true;
            }
        },
        promoCheck() {
            if (!this.promoCode) return;

            this.promoLoader = true;

            codeCheck(this.promoCode).then(response => {
                this.promoLoader = false;

                if (response.status === 'ok') {
                    this.promoIsInvalid = false;
                    this.promoIsOn = true;
                    this.promoInfo = response.p;
                    if (response.p.free_delivery) {
                        this.count_for_delivery_free = 1;
                    }
                } else {
                    this.promoIsInvalid = true;
                    this.promoIsOn = false;
                }
            });
        },
    },
};
</script>
